import { Link } from 'react-router-dom';
import { memberBenefits } from '@/mocks/home';

export default function MemberSection() {
  return (
    <section id="member" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium mb-4">
            会员专区
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            加入亚洲在线会员
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            尊享四大核心权益，开启更优质的数字生活体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {memberBenefits.map((benefit) => (
            <div
              key={benefit.id}
              className="p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-50 text-primary-600 mb-4">
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base transition-colors whitespace-nowrap cursor-pointer"
          >
            立即加入会员 <i className="ri-arrow-right-line"></i>
          </Link>
          <p className="mt-3 text-xs text-foreground-400">
            注册即享基础会员权益，高级会员月费仅需 ¥29.9
          </p>
        </div>
      </div>
    </section>
  );
}